interface Config {
    env: string;
    WORDSMITH_SERVER_URL_BASE: string;
}


const localhost: Config = {
    env: "localhost",
    WORDSMITH_SERVER_URL_BASE: "http://localhost:3000",
}

const dev: Config = {
    env: "dev",
    WORDSMITH_SERVER_URL_BASE: "https://wordsmithapi-dev.bluecanoelearning.com",

}

const prod: Config = {
    env: "prod",
    WORDSMITH_SERVER_URL_BASE: "https://wordsmithapi.bluecanoelearning.com",
}

export const getConfig = (): Config => {
    const awsBranch = process.env.REACT_APP_AWS_BRANCH;
    if (awsBranch === "localhost") {
        return localhost;
    } else if (awsBranch === "dev") {
        return dev;
    } else if (awsBranch === "main") {
        return prod;
    } else {
        return localhost;
    }
}

